"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normalizer = exports.normalizerDestructive = exports.normalizationsDestructive = exports._spaceNonSemanticGlyphs = exports._greekNonSemanticGlyphs = exports._hebrewNonSemanticGlyphs = void 0; // Constants:
// NOTE: in UHB, maqqef 05BE is followed by 2060, word joiner.
// Therefore, we should NOT strip maqqef to match tokenization, which splits on nonword characters.

var _hebrewNonSemanticGlyphs = [{
  inputs: [/[\u0591-\u05AF\u05BD\u05C0\u05C3-\u05C5\u2060]/gi],
  output: ''
}]; // https://unicode-table.com/en/#combining-diacritical-marks

exports._hebrewNonSemanticGlyphs = _hebrewNonSemanticGlyphs;
var _greekNonSemanticGlyphs = [{
  inputs: [/[\u0300-\u0362\u0374-\u0375\u037a\u0384-\u0385\u0387]/g],
  output: ''
}];
exports._greekNonSemanticGlyphs = _greekNonSemanticGlyphs;
var _spaceNonSemanticGlyphs = [{
  inputs: [/(\u200B)/g],
  output: ''
}, {
  inputs: [/\s+/g],
  output: ' '
}];
exports._spaceNonSemanticGlyphs = _spaceNonSemanticGlyphs;
var normalizationsDestructive = [].concat(_hebrewNonSemanticGlyphs).concat(_greekNonSemanticGlyphs).concat(_spaceNonSemanticGlyphs);
/**
 * @param {String} string - The string to normalize
 * @param {[{inputs:[RegExp], output:String}]} normalizations - Normalization Objects to perform the replace with
 * @return {String} - The normalized string
 */

exports.normalizationsDestructive = normalizationsDestructive;

var normalizerDestructive = function normalizerDestructive(string) {
  var normalizations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : normalizationsDestructive;

  var _string = normalizer(string);

  if (string && normalizations) {
    _string = _string.slice(0);
    normalizations.forEach(function (_ref) {
      var inputs = _ref.inputs,
          output = _ref.output;
      inputs.forEach(function (input) {
        _string = _string.replace(input, output);
      });
    });
  }

  return _string;
};
/**
 * Normalize a string: standard Javascript normalization, providing default form.
 * @return {String} normalized string.
 */


exports.normalizerDestructive = normalizerDestructive;

var normalizer = function normalizer() {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var form = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'NFKD';
  text = text.normalize(form);
  return text;
};

exports.normalizer = normalizer;